import { API_BETA, jsonHeadersWithToken, parseJsonSafe, getErrorMessage } from '@/lib/constants'

const BASE_URL = API_BETA
export const getOverviewData = async (project = null) => {
  const params = new URLSearchParams()
  if (project) params.append('project', project)

  const url = `${BASE_URL}guest/web-builder/overview${params.toString() ? `?${params.toString()}` : ''}`

  const response = await fetch(url, {
    method: 'GET',
    headers: jsonHeadersWithToken(),
  })

  if (!response.ok) {
    const errorData = await parseJsonSafe(response)
    const message = getErrorMessage(errorData, 'Failed to fetch overview data')
    throw new Error(message)
  }

  const result = await parseJsonSafe(response)
  return result.data || result
}

export const enableAnalytics = async (project) => {
  const params = new URLSearchParams()
  if (project) params.append('project', project)

  const url = `${BASE_URL}guest/analytics/create-website${params.toString() ? `?${params.toString()}` : ''}`

  const response = await fetch(url, {
    method: 'POST',
    headers: jsonHeadersWithToken(),
  })

  if (!response.ok) {
    const errorData = await parseJsonSafe(response)
    const message = getErrorMessage(errorData, 'Failed to enable analytics')
    throw new Error(message)
  }

  const result = await parseJsonSafe(response)
  return result.data || result
}
